import { queryOptions } from "@tanstack/react-query";

import * as workspacesApi from "./workspaces-api";

export const superuserWorkspacesQueries = {
  root: () => ["superuser-workspaces"] as const,
  /**
   * CR-178: every live workspace on the platform — the page's only source.
   * Admin-only RPC (assert_platform_admin() server-side, 42501 otherwise),
   * not audit-logged. The "platform-all" segment is CR-116's key, kept to
   * avoid cache churn.
   */
  list: () =>
    queryOptions({
      queryKey: [...superuserWorkspacesQueries.root(), "platform-all"] as const,
      queryFn: () => workspacesApi.listPlatformWorkspaces(),
      staleTime: 30 * 1000,
    }),
};
